import { routes } from "./business";

export const heroChips = [
  "Free Consultations",
  "Free Rides Home from Jail",
  "Flexible Payment Plans & Financing",
  "100% Confidential",
];

export const trustBadges = [
  { key: "veteran", label: "Veteran Owned (USMC)" },
  { key: "chamber", label: "Las Vegas Chamber of Commerce Member" },
  { key: "local", label: "Locally Owned" },
  { key: "licensed", label: "Licensed Since 2012" },
  { key: "since", label: "Serving Clark County Since 2011" },
  { key: "google", label: "Google Rating [[FILL IN]]" },
] as const;

export const bailSteps = [
  {
    title: "Call or Start Online",
    body: "Free consultation, any hour. Tell us who's in custody and where — we'll take it from there.",
  },
  {
    title: "We Locate & Calculate",
    body: "We find your loved one and tell you the exact cost, so there are no surprises.",
  },
  {
    title: "Simple Payment",
    body: "Debit, credit, cash, or ask about OAC financing and payment plans.",
  },
  {
    title: "They Come Home",
    body: "We post the bond fast and can provide a free ride home from jail.",
  },
];

export const differentiators = [
  { key: "respect", title: "Respectful Treatment", body: "Courtesy and dignity for every client, whatever the reason for arrest." },
  { key: "personal", title: "Personal Attention", body: "Before and after the bond — we stay with you, not hand you off." },
  { key: "consult", title: "Free Consultations", body: "Ask anything, any hour. No cost, no pressure." },
  { key: "ride", title: "Free Rides Home", body: "We can pick your loved one up from jail at no charge." },
  { key: "payment", title: "Payment Plans & Financing", body: "Flexible plans and OAC financing to fit your situation." },
  { key: "private", title: "Total Confidentiality", body: "Your case is handled privately, start to finish." },
] as const;

export const bondTools = [
  { key: "inmate", title: "Find an Inmate", body: "Locate your loved one and get their case number.", to: `${routes.getBond}#find-inmate` },
  { key: "calc", title: "Bail Calculator", body: "See the exact bond cost under Nevada law.", to: `${routes.getBond}#calculator` },
  { key: "pay", title: "Pay Online", body: "Secure, encrypted payment from anywhere.", to: `${routes.getBond}#pay` },
  { key: "forms", title: "Download Forms", body: "Bond agreement and indemnitor application.", to: `${routes.getBond}#forms` },
] as const;

export const bondTypes = [
  { title: "DUI", body: "Arrested for driving under the influence? We post DUI bonds around the clock." },
  { title: "Drug Possession", body: "Discreet, judgment-free help with possession charges." },
  { title: "Assault", body: "We move quickly so your loved one can prepare for court at home." },
  { title: "Theft", body: "From shoplifting to larceny — we handle theft bonds every day." },
  { title: "Computer Crimes", body: "Experienced, confidential help with cyber-related charges." },
];

export const resourceTopics = [
  "Inmate search",
  "Visitation",
  "Sending money",
  "Accepting calls",
  "Courts & calendars",
  "Court records",
  "Victim's resources",
];

export const faqs = [
  {
    q: "How much does a bail bond cost in Nevada?",
    a: "Nevada law (NRS 697.300) sets the bail bond premium at 15% of the bail amount, or $50, whichever is greater. The jail also charges a $50 filing fee for each case number.",
  },
  {
    q: "How fast can my loved one get out?",
    a: "We start immediately. Release time depends on the jail's processing, and we'll walk you through every step while you wait.",
  },
  {
    q: "Can I post bail if I'm out of state?",
    a: "Yes. Use our online steps and secure online payment — you don't need to be in Las Vegas.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Debit or credit card, cash, and OAC financing or payment plans. Call 702-384-7777 to talk through options.",
  },
  {
    q: "Is my information kept private?",
    a: "Yes. Everything you share with us is 100% confidential.",
  },
  {
    q: "Do you give rides home from jail?",
    a: "Yes. We offer free pick-ups from jail.",
  },
  {
    q: "Which jails do you serve?",
    a: "Clark County Detention Center, Las Vegas City Jail, North Las Vegas Jail, Henderson Detention Center, and all of Clark County.",
  },
  {
    q: "What is an indemnitor?",
    a: "The indemnitor is the person who signs for the bond and guarantees the defendant will appear in court. It's often a family member or close friend.",
  },
];
